import { render } from "./SummaryTableParametres.vue?vue&type=template&id=06ef6699"
import script from "./SummaryTableParametres.vue?vue&type=script&lang=js"
export * from "./SummaryTableParametres.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__